export function readSlidesData(scope) {
  return Array.from(scope.querySelectorAll('.slides-data__item')).map(function (item) {
    return {
      title: item.getAttribute('data-title') || '',
      modal: item.getAttribute('data-modal') || '',
      image: item.getAttribute('data-image') || '',
      video: item.getAttribute('data-video') || '',
      audioMild: item.getAttribute('data-audio-mild') || '',
      audioModerate: item.getAttribute('data-audio-moderate') || '',
      audioSevere: item.getAttribute('data-audio-severe') || ''
    };
  });
}

export function resolveSummaryMediaUrl(raw) {
  if (!raw) {
    return '';
  }

  if (/\.mp3(\?|$)/i.test(raw)) {
    return raw
      .replace(/\/audios\/summary\/summary\.mp3/i, '/videos/summary.mp4')
      .replace(/^assets\/audios\/summary\/summary\.mp3/i, 'assets/videos/summary.mp4');
  }

  return raw;
}

export function readSummaryMediaUrl(summaryRoot) {
  if (!summaryRoot) {
    return '';
  }

  return resolveSummaryMediaUrl(summaryRoot.getAttribute('data-summary-audio') || '');
}
